export default {


    bodyClass : function( class_ ){

        $('body').addClass( class_ )
    
    },

    getMedia : function( path , env ){

        // If path is already an absolute URL, return it as-is
        if (path && (path.startsWith('http://') || path.startsWith('https://'))) {
            return path;
        }

        let path_ = path.replace('/images/','images/upload/') ;
        return env.VUE_APP_UPLOAD_MEDIAS + path_ ;

    },

    formatContent( content_markdown , env ){

        if (!content_markdown) return '';

        // Match src="/images/..." and replace with upload URL
        // Use a function to handle edge cases and avoid mangling absolute URLs
        const searchRegExp = /src="(\/images\/[^"]+)"/g ;

        const out = content_markdown.replace( searchRegExp , (match, path) => {
            // Safety check: if path somehow contains absolute URL markers, return unchanged
            if (path.includes('://') || path.includes('http')) {
                return match;
            }
            // Remove the leading /images/ and prepend the upload URL
            const filename = path.replace('/images/', '');
            return `src="${env.VUE_APP_UPLOAD_MEDIAS_UPLOAD}${filename}"`;
        });

        return out ;
    },

    bodyClassRemove : function( class_ ){

        $('body').removeClass( class_ )
    
    }, 

    // Helper function to convert Roman numerals to numbers
    romanToInt : function (roman) {
      
      const map = { I: 1, V: 5, X: 10, L: 50, C: 100, D: 500, M: 1000 };
      let total = 0;
      let prev = 0;

      for (let i = roman.length - 1; i >= 0; i--) {
        const curr = map[roman[i].toUpperCase()];
        if (curr < prev) total -= curr;
        else total += curr;
        prev = curr;
      }
      return total;
    
    }, 

    // Sort function
    sortByRoman : function (arr) {
      
      return arr.sort((a, b) => {
        const romanA = a.match(/[IVXLCDM]+/i)[0]; // extract Roman numeral
        const romanB = b.match(/[IVXLCDM]+/i)[0];
        return this.romanToInt(romanA) - this.romanToInt(romanB);
      });
    
    },

    exposeKey : function( key , root_ , trans ){

        let key_node = key ;
        let node = `${root_}-${key_node}`
        node = node.replace('-overview','')

        return node ; 
    
    },

    showLoader : function( extra_items = undefined ){

        $('#loader').fadeIn() ;
    },

    hideLoader : function( extra_items = undefined ){

        // first action to do, remove loader
        // eslint-disable-next-line
        $('#loader').fadeOut('slow');
        // eslint-disable-next-line

        let fadeInExtra = ( extra_items != undefined ) ? extra_items : '' ; 

        $(`.fadeIn${fadeInExtra}`).fadeIn('slow');

    }, 

    moveSnippet : function( type ){

        if ( type == 'all' ){

            $('fieldset.container_snippet_volume_all')
                .insertAfter('#re-rendering') 
                .css({ opacity : 1 , height : 'auto' })
            ; 
        } 
        else if ( type == 'plus' ){

            $('fieldset.container_snippet_volume_plus')
                .insertAfter('#re-rendering') 
                .css({ opacity : 1 , height : 'auto' })
            ; 
        } 


    },

    ci5SubMenu : function(){

        return [
            { name : 'Data visualization' , route : 'ci5_dataviz' } ,
            { name : 'About CI5' , route : 'ci5_about'  }
        ]

    },  

    mapRegistry : function( registry_id , data_country , data_reg ) {

        
        
    },

    buildCI5Object : function( v ){

        let ext = 'png' , volum_str = v.volume ; 

        if ( parseFloat( v.volume ) < 10) volum_str = volum_str.replace('0','')
        if ( [7,8,9,12].includes( parseFloat( v.volume ) )) ext = 'jpg' ; 
        if ( [1,2,3,4,5,6].includes( parseFloat( v.volume ) )) ext = 'gif' ; 
        if ( [1,2,3,4,5,6,10].includes(parseFloat( v.volume ) )) volum_str = volum_str+'a' ; 

        v.url = `/iacr/en/ci5-2.0/volume/${v.volume}/`
        v.desc = v.years
        v.image = `${this.$store.state.env.VUE_APP_GCO_MEDIAS}/ci5/img/ci5v${volum_str}.${ext}` ; 

        return v ; 

    },

    datavizSubMenu : function(){
        
        return [
          // { key : 'about' , type : 'page' },
          // { key : 'database', type : 'page' },
          { key : 'tables', type : 'dataviz' , route : 'tables' , image : 'time_table.svg' },
          { key : 'bars', type : 'dataviz', route : 'bars' , image : 'bar-horizontal.svg' },
          { key : 'age-specific', type : 'dataviz' , route : 'age_specific' , image : 'line_graph.svg' },
          { key : 'population_pyramid', type : 'population_pyramid' , route : 'population_pyramid' , image : 'dual.svg' } ,
          //{ key : 'compare', type : 'compare' , route : 'compare' }
        ] ;

    },

    filterByVolume : function( dataset , volume ){

        // console.info("dataset",parseFloat( volume ), dataset)
        return dataset.filter( d => d.year == parseFloat( volume ) )

    },

    titleVolume : function( filters , vol , volumes ){
        
        if ( vol == 'plus') return 'CI5<i>Plus</i>' ; 
        else if ( vol == 'all') return 'CI5 Vol. I to XII (All)' ; 
        
        let volume = volumes.find( v => v.volume == vol ) ; 

        return 'CI5 Vol.' +volume.label + ' '+volume.years ; 

    },

    getVolumeFromUrl : function( ){

        let pathParams = window.location.pathname.replace(/\/+$/, '').split('/').filter(Boolean); // ['iacr','en','ci5-2.0','dataviz','01','bars']
        let datavizIndex = pathParams.indexOf('dataviz');
        // console.info("pathParams",pathParams,"datavizIndex",datavizIndex," => " , pathParams[datavizIndex+1])
        return pathParams[datavizIndex+1];

    },
    
    /**
    * Helper to get current dynamic comp
    * @param (object)
    * @param (string) name of comp
    * @return (string|int|object|array) the current value
    */
    getDC : function( filters , name_comp , default_ ){

        let comp_item = filters.dynamic_components.find( d => d.name == name_comp ) ; 

        // console.log("A name_comp",name_comp,comp_item,comp_item.config.current) ; 

        if ( comp_item != undefined )
            if ( comp_item.config != undefined ) 
                if ( comp_item.config.current != undefined){
                    if ( comp_item.config.current.value != undefined && comp_item.config.current.label != undefined )
                        return comp_item.config.current ; 
                    else
                        return { value : comp_item.config.current , label : comp_item.config.title , component : comp_item  } ; 
                }

        // console.log("B name_comp",name_comp,comp_item,comp_item.config.current) ; 

        return { value : default_ , label : '' , component : comp_item }

    },

    /***
    * For a single zoom item, we define a level of scale, translatet and all doms items to hide
    * @param (int|string) define by id (continent, area, region,hdi) or string (hub, who)
    * @param (string) whether it or not the globe mode
    *
    * Poly and lines are really difficult to identify sometimes
    * 
    * .maskpoly.poly-1 is the lakes in Africa
    * .maskpoly.poly-2 is the area of Jammu and Kashmir
    * 
    * .line-1 is 
    * .line-4 is the border separating West Gaza Bank & Israel (dashed)
    * .line-6 is the left border separation of Jammu and Kashmir
    * .line-7 is the right separation Sudan region (dashed)
    * .line-8 is the left separation Sudan region (dashed)
    * .line-9 & .line-10 is the grey zone around Sudan region (dashed)
    * .line-11 is an horizontal line around Qatar/Iran/Irak region
    *
    */
    getIsoPerRegion : function( zoom , is_globe ){

        let iso = undefined, scale , translate , items_to_hide , table_threshold = [290,290] ; 

        // determine which country/zone to zoom in
        switch(zoom){

            // small threshold of map to the left
            case -1 :
                iso = 'FRA' ; 
                scale = 1 ; 
                translate = { 'x' : -10 , 'y' : 0 } ; 
                items_to_hide = [] ; 

                break ; 

            // Africa
            case 1: case '1' : case 'who_AFRO' : case 'AFRO' : case 'hub_africa' : // Africa | sub saharan africa hub
                iso = 'CMR' ; // Tchad 
                scale = 1.7 ; 
                translate = { 'x' : 180 , 'y' : -50 } ; 
                items_to_hide = ['.poly-0','.poly-1','.poly-2','.line-1','.line-2','.line-3','.line-4','.line-6','.line-9','.line-10','.line-11','#aksai-chin','#jammu-and-kashmir'] ; 
                table_threshold = [180,90]
                break ;

            // South America 
            case 2: case  '2' :  case 'hub_latin' : // South America 
                iso = 'BRA' ; // Ecuador 
                scale = 1.8 ; 
                translate = { 'x' : 150 , 'y' : -50 } ; 
                items_to_hide = ['.poly-0','.poly-1','.poly-2','.line-1','.line-2','.line-3','.line-4','.line-6','.line-9','.line-10','.line-11']
                table_threshold = [220,50] 
                break ;

            // North America 
            case 3: case  '3' : 
                iso =  'USA' 
                scale = 1.8 ;
                translate = { 'x' : 200 , 'y' : -20 } ;  
                items_to_hide = ['.line-3']
                break ;

            // Asia 
            case 4: case  '4' : case 'hub_mumbai' : // Asia 
                iso = ( is_globe == true  ) ? 'IND' : 'CHN' ; // China 
                scale = 1.6 ; 
                translate = { 'x' : 140 , 'y' : -50 } ; 
                items_to_hide = ['.poly-1','.poly-2','.line-9','.line-10','.line-3']
                break ;

            // Europe
            case 5: case  '5' : //
                iso = 'FRA' ; // Hungary 
                scale = 2.5 ; 
                translate = { 'x' : 200 , 'y' : -50 } ;
                items_to_hide = ['.poly-0','.poly-1','#aksai-chin','#jammu-and-kashmir','.line-1','.line-3','.line-4','.line-6','.line-11'] ; 
                table_threshold = [220,50]
                break ;

            // WHO EURO
            case 'EURO' :  
                iso = 'FRA' ; // Hungary 
                scale = 1.9 ; 
                translate = { 'x' : 190 , 'y' : -50 } ;
                break ;

            case 6: case '6' : // Oceania 
            case 'hub_pacific' : 
                iso = ( is_globe == true  ) ? 'AUS' :  'FJI' ; // Australia 
                scale = 2.4 ; 
                translate = { y : -50 , x : 50 } ;
                items_to_hide = ['.poly-0','.poly-1','#aksai-chin','#jammu-and-kashmir','.line-1','.line-3','.line-4','.line-6','.line-11'] ; 
                break ;
        }

        return {
            iso : iso , 
            scale : scale , 
            translate : translate , 
            items_to_hide : items_to_hide , 
            table_threshold : table_threshold
        }

    }

}